const comparableNamePart = (value: string) =>
  value.toLocaleLowerCase().replace(/[.,]+$/g, '');

export const managedUserDisplayName = (value: string): string => {
  const parts = value.trim().split(/\s+/).filter(Boolean);
  let changed = true;

  while (changed) {
    changed = false;
    const largestCandidate = Math.floor((parts.length - 1) / 2);
    for (let length = largestCandidate; length >= 1; length -= 1) {
      const trailing = parts.slice(-length).map(comparableNamePart);
      const preceding = parts.slice(-2 * length, -length).map(comparableNamePart);
      if (
        trailing.length === preceding.length &&
        trailing.every((part, index) => part === preceding[index])
      ) {
        parts.splice(-length, length);
        changed = true;
        break;
      }
    }
  }

  return parts.join(' ');
};
